import { jsx } from "react/jsx-runtime";
import {
  forwardRef,
  useCallback,
  useRef
} from "react";
import { clamp } from "../utils.js";
const TrackMouseMove = forwardRef(
  function TrackMouseMove2(inProps, outerRef) {
    const { children, className, onChange, style, testId = "TrackMouseMove" } = inProps;
    const innerRef = useRef(null);
    const setRef = (element) => {
      if (typeof outerRef === "function") outerRef(element);
      else if (outerRef) outerRef.current = element;
      innerRef.current = element;
    };
    const move = useCallback(
      (e) => {
        if (innerRef.current) {
          const { current: div } = innerRef;
          const { width, height, left, top } = div.getBoundingClientRect();
          const x = clamp(e.clientX - left, width, 1);
          const y = clamp(e.clientY - top, height - 1, 0);
          onChange({ x, y });
        }
      },
      [onChange]
    );
    const onMouseDown = (e) => {
      if (e.button !== 0) return;
      move(e);
      const onMouseMove = (_e) => {
        move(_e);
      };
      const onMouseUp = (_e) => {
        document.removeEventListener("mousemove", onMouseMove, false);
        document.removeEventListener("mouseup", onMouseUp, false);
        move(_e);
      };
      document.addEventListener("mousemove", onMouseMove, false);
      document.addEventListener("mouseup", onMouseUp, false);
    };
    return /* @__PURE__ */ jsx("div", { className, "data-testid": testId, onMouseDown, ref: setRef, style, children });
  }
);
export {
  TrackMouseMove
};
//# sourceMappingURL=TrackMouseMove.js.map
